function windowConfig(varName) {
  if (window.config) {
    return window.config[varName]
  } else {
    return undefined
  }
}

export default {
  MK_BACKOFFICE_URL: windowConfig('VUE_APP_MK_BACKOFFICE_URL') || process.env.VUE_APP_MK_BACKOFFICE_URL || 'https://backoffice.dev.kodland.org/',
  MK_API: windowConfig('VUE_APP_MK_API') || process.env.VUE_APP_MK_API || 'https://booking-back.dev.kodland.org/',
  MK_BACKOFFICE_API: windowConfig('VUE_APP_MK_BACKOFFICE_API') || process.env.VUE_APP_MK_BACKOFFICE_API || 'https://backoffice.dev.kodland.org/api/v1/',
  MK_BACKOFFICE_API_V2: windowConfig('VUE_APP_MK_BACKOFFICE_API_V2') || process.env.VUE_APP_MK_BACKOFFICE_API_V2 || 'https://backoffice.dev.kodland.org/api/v2/',
  SSO_API: windowConfig('VUE_APP_SSO_API') || process.env.VUE_APP_SSO_API || 'https://sso.dev.kodland.org/',
  AMO_LINK:  'https://kodland.amocrm.ru/leads/detail/',
  BACKOFFICE_LINK : windowConfig('VUE_APP_BACKOFFICE_LINK') || process.env.VUE_APP_BACKOFFICE_LINK || 'https://bo.dev.kodland.org/students/',
  TIMESLOTS_WS: windowConfig('VUE_APP_TIMESLOTS_WS') || process.env.VUE_APP_TIMESLOTS_WS || 'wss://booking-back.dev.kodland.org/ws-timeslots/get_available/?date='
}
